import { Routes, Route, useNavigate } from "react-router-dom";
import {
  SiteContainer,
  NotFound,
  ProtectedRoute,
  Alert,
} from "@mikros/shared-ui";
import { MenuItem, ProtectedRouteProps } from "@mikros/library";
import { Home } from "./components/home/home";
import { NewSchedule } from "./components/scheduler/createSchedule/newSchedule";
// import { UserPage } from "./components/users/users";
import { Scheduler } from "./components/scheduler/scheduler";
import { Analytics } from "./components/analytics/analytics";
import { useEffect, useRef, useState } from "react";
import AuthService from "./service/authService";
import { CreateCourse } from "./components/courses/createCourse";
import { useIntl } from "react-intl";
import French from "./i18n/fr.json";
import English from "./i18n/en.json";
import { Organization } from "./components/organization/organization";
import { Personal } from "./components/personal/personal";
import { jwtDecode } from "jwt-decode";
import { Course } from "./components/courses/course";
import { EditCourse } from "./components/courses/editCourse";
import { useAuthenticator } from "@aws-amplify/ui-react";
import Account from "./utils/apiConfig";
import { ResetPassword } from "./components/personal/resetPassword";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Audits } from "./components/audits/audits";
import { UserPageDup } from "./components/users/usersDup";

export default function AppRoutes() {
  const intl = useIntl();
  const { route, authStatus, user, toSignIn } = useAuthenticator((context) => [
    context.route,
  ]);
  console.log(
    "authstatus1 adfadadsfada",
    route,
    authStatus,
    user,
    typeof toSignIn
  );

  const navigate = useNavigate();
  const accountInstance = Account.getInstance();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [hasNavigatedHome, setHasNavigatedHome] = useState(false);
  const [logOutSuccess, setlogOutSuccess] = useState<boolean>(false);

  console.log("has navigated home value", hasNavigatedHome);
  const [locale, setLocale] = useState("en");
  const messages = loadLocaleData(locale);

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);
  const accntId = accountInstance.accntId;
  const subId = subRef.current;
  const nameValue = useRef(null);

  useEffect(() => {
    async function initializeAndUseAccount() {
      await accountInstance.fetchAccountId();
      console.log(
        "account id instance in tenant side home use Effect afadsa",
        accountInstance.accntId
      );
    }
    initializeAndUseAccount();
  }, []);

  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      const name = decoded["name"];
      nameValue.current = name;
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect", subValue);
    }
    fetchSub();
  }, []);

  useEffect(() => {
    if (route === "authenticated") {
      console.log("entered route use effect", route);
      if (!isAuthenticated) {
        console.log("entered if of not authenticated");
        setIsAuthenticated(true);
        navigate("/home");
      }
    }
  }, [route]);

  const defaultProtectedRouteProps: Omit<ProtectedRouteProps, "outlet"> = {
    isAuthenticated: true,
    authenticationPath: "/login",
  };

  let siteMenu: MenuItem[] = [
    {
      text: `${intl.formatMessage({
        id: "appRoutes.homeTab",
      })}`,
      icon: "fa-house",
      link: "/home",
      title: `${intl.formatMessage({
        id: "appRoutes.homeTab",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.courseTab",
      })}`,
      icon: "fa-book-open",
      link: "/courses",
      title: `${intl.formatMessage({
        id: "appRoutes.createNewCourse",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.usersTab",
      })}`,
      icon: "fa-users",
      link: "/users",
      title: `${intl.formatMessage({
        id: "appRoutes.usersTab",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.scheduleTab",
      })}`,
      icon: "fa-calendar-days",
      link: "/scheduler",
      title: `${intl.formatMessage({
        id: "appRoutes.allSchedules",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        // id: "appRoutes.analyticsTab",
        id: "appRoutes.reportsTab",
      })}`,
      icon: "fa-chart-simple",
      // link: "/analytics",
      link:"/reports",
      title: `${intl.formatMessage({
        // id: "appRoutes.analyticsTab",
        id: "appRoutes.reportsTab",
      })}`,
    },
    {
      text: `${intl.formatMessage({
        id: "appRoutes.auditTab",
      })}`,
      // icon: "fa-chart-simple",
      icon: "fa-circle-check",
      link: "/audit",
      title: `${intl.formatMessage({
        id: "appRoutes.auditTab",
      })}`,
    },
  ];

  const toggleLogOutDialog = () => {
    setlogOutSuccess(!logOutSuccess);
  };

  const logout = async () => {
    await AuthService.getInstance()
      .signOut()
      .then((response) => {
        // toast.success("Sign out successfully");
        toggleLogOutDialog();
        navigate("/");
      });
  };

  function loadLocaleData(locale: string) {
    switch (locale) {
      case "fr":
        return French;
      default:
        return English;
    }
  }

  return (
    <div>
      <div className="overflow-y-hidden">
        {logOutSuccess && (
          <Dialog className="confirmSuccessDialogue">
            <Alert
              description={intl.formatMessage({
                id: "appRoutes.logOut",
              })}
              buttonText={`${intl.formatMessage({
                id: "users.buttonText.Ok",
              })}`}
              icon={"successShape.png"}
              iconMsg={intl.formatMessage({
                id: "iconMsgSuccess",
              })}
              backgroundColor={"mk-bright-green"}
              onClick={() => {
                toggleLogOutDialog();
              }}
            />
          </Dialog>
        )}

        {/* <IntlProvider locale={locale} defaultLocale={"en"} messages={messages}> */}
        <Routes>
          <Route
            path="/"
            element={
              <SiteContainer
                menu={siteMenu}
                logout={() => logout()}
                accId={accntId}
                subId={subId}
                userName={nameValue.current!!}
              />
            }
          >
            <Route
              path="/home"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Home />}
                />
              }
            />
            <Route
              path="/courses"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={
                    accountInstance.accntRole === "tnt_auditor" ? (
                      <Dialog className="errorDialogue">
                        <Alert
                          description={intl.formatMessage({
                            id: "users.permissionDenied",
                          })}
                          buttonText={`${intl.formatMessage({
                            id: "users.buttonText.Ok",
                          })}`}
                          icon={"errorShape.png"}
                          iconMsg={intl.formatMessage({
                            id: "iconMsgError",
                          })}
                          backgroundColor={"mk-red"}
                          onClick={() => {
                            navigate("/home");
                          }}
                        />
                      </Dialog>
                    ) : (
                      <Course />
                    )
                  }
                />
              }
            />
            <Route
              path="/editCourse"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<EditCourse />}
                />
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  // outlet={<UserPage />}
                  outlet={<UserPageDup />}
                />
              }
            />
            <Route
              path="/scheduler"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Scheduler />}
                />
              }
            />
            <Route
              // path="/analytics"
              path="/reports"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Analytics />}
                />
              }
            />

            <Route
              path="/audit"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Audits />}
                />
              }
            />

            <Route
              path="/newSchedule"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<NewSchedule />}
                />
              }
            />
            <Route
              path="/createCourse"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<CreateCourse />}
                />
              }
            />
            <Route
              path="/organization/:id"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Organization />}
                />
              }
            />
            <Route
              path="/personal/:id"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<Personal />}
                />
              }
            />

            <Route
              path="/reset-password/:id"
              element={
                <ProtectedRoute
                  {...defaultProtectedRouteProps}
                  outlet={<ResetPassword />}
                />
              }
            />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </div>
    </div>
  );
}
